import { render, staticRenderFns } from "./MultiRegionPlot.vue?vue&type=template&id=7e29676e&scoped=true"
import script from "./MultiRegionPlot.vue?vue&type=script&lang=js"
export * from "./MultiRegionPlot.vue?vue&type=script&lang=js"
import style0 from "./MultiRegionPlot.vue?vue&type=style&index=0&id=7e29676e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e29676e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e29676e')) {
      api.createRecord('7e29676e', component.options)
    } else {
      api.reload('7e29676e', component.options)
    }
    module.hot.accept("./MultiRegionPlot.vue?vue&type=template&id=7e29676e&scoped=true", function () {
      api.rerender('7e29676e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/multiSectionComponents/MultiRegionPlot.vue"
export default component.exports